import { ServiceInvoiceType } from "@redotech/redo-billing-common/service-invoice";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const refreshBilling = {
  name: "refreshBilling" as const,
  input: z.object({
    teamId: zExt.objectId(),
    type: createEnum(ServiceInvoiceType),
  }),
  output: z.null(),
};
